import { render, staticRenderFns } from "./Product_List.vue?vue&type=template&id=124b8001&scoped=true&"
import script from "./Product_List.vue?vue&type=script&lang=js&"
export * from "./Product_List.vue?vue&type=script&lang=js&"
import style0 from "./Product_List.vue?vue&type=style&index=0&id=124b8001&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b8001",
  null
  
)

export default component.exports